import { Injectable } from '@angular/core';
import { ApiService, ApiCacheOptions } from '../../shared/index';
import { Entity } from './entity.model';
import { IEntityService } from './ientity.service';

@Injectable({ providedIn: 'root' })
export class EntityService implements IEntityService {
  private _apiService: ApiService;
  private _apiCacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._apiCacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
  }

  public getEntities = (): Promise<Array<Entity>> => {
    return this._apiService.get('Entities', this._apiCacheOptions);
  };

  public getEntity = (entityId: number): Promise<Entity> => {
    return this._apiService.get(`Entity/${entityId}`, this._apiCacheOptions);
  };

  public deleteEntity = (entityId: number): Promise<void> => {
    return this._apiService.delete(`Entity/${entityId}`);
  };

  public updateEntity = (entity: Entity): Promise<number> => {
    return this._apiService.put(`Entity/${entity.EntityID}`, entity);
  };

  public createEntity = (entity: Entity): Promise<number> => {
    return this._apiService.post('Entity', entity);
  };

  public hasEntityRelation = (entityId: number): Promise<boolean> => {
    return this._apiService.get(`Entity/${entityId}/HasEntityRelation`, this._apiCacheOptions);
  };
}
